import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import MobileCallBar from "./MobileCallBar";
import { captureUtm, initAnalytics, pageView } from "@/lib/track";

export default function Layout() {
  const { pathname, hash } = useLocation();
  useEffect(() => { captureUtm(); initAnalytics(); }, []);
  useEffect(() => { const t = setTimeout(() => pageView(pathname), 300); return () => clearTimeout(t); }, [pathname]);
  useEffect(() => {
    if (hash) setTimeout(() => document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" }), 400);
    else window.scrollTo(0, 0);
  }, [pathname, hash]);
  return (
    <div className="min-h-screen bg-[#0F1115] pb-20 md:pb-0">
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
      <MobileCallBar />
    </div>
  );
}
